interface SvgPlusProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}
export default function SvgPlus(props: SvgPlusProps) {
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}><path d="M12.75 11.25V6H11.25V11.25H6V12.75H11.25V18H12.75V12.75H18V11.25H12.75Z" fill="currentColor" /></svg>;
}